export enum ErrorCode {
  ALREADY_EXISTS = 1001,
  INVALID_CREDENTIALS = 1003,
  // PERMISSION_DENIED = 1003,
  DEFAULT = 9999,
}
